import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';
import PostContent from '../../../components/Presentation/PostContent';
import { Spinner, Expandable } from 'UI';
import MyTasks from '../../Overview/Sections/MyTasks';
import MyPlanning from '../../Overview/Sections/MyPlans';
import MyPosts from '../../Overview/Sections/MyPosts';
import SectionProgress from 'containers/Progress/Section';
import { getDescription } from 'helpers/content';
var CompulsorySchoolSection = /*#__PURE__*/function (_Component) {
  function CompulsorySchoolSection(props) {
    var _this;
    _classCallCheck(this, CompulsorySchoolSection);
    _this = _callSuper(this, CompulsorySchoolSection, [props]);
    _defineProperty(_this, "updateDates", function () {
      var _this$state = _this.state,
        dtStart = _this$state.dtStart,
        dtEnd = _this$state.dtEnd;
      _this.setState({
        loaded: false,
        start: dtStart,
        end: dtEnd
      });
      _this.props.clearMatrixAssessmentOverview();
    });
    _defineProperty(_this, "onDateChange", function (dates) {
      if (dates.start != _this.state.dtStart || _this.state.end != dates.dtEnd) {
        _this.setState({
          dtStart: dates.start,
          dtEnd: dates.end
        });
      }
    });
    _defineProperty(_this, "renderGroupContent", function () {
      var group = _this.props.group;
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section left-side"
      }, group.description ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostContent, null, getDescription(group.description))) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), _this.props.activeStudent != null && _this.props.activeStudent.services.news ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(MyPosts, {
        overview: true,
        limit: 3,
        groupid: group.id
      })) : null, _this.props.activeStudent != null && _this.props.activeStudent.services.plans ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(MyPlanning, {
        overview: true,
        groupid: group.id,
        dateRestriction: false
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(MyTasks, {
        overview: true,
        groupid: group.id,
        limit: false
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "single-section-divider"
      }), /*#__PURE__*/React.createElement("div", {
        id: "section-assessment",
        className: "single-section form"
      }, /*#__PURE__*/React.createElement(SectionProgress, {
        start: _this.state.start,
        end: _this.state.end,
        groupId: group.id,
        userId: _this.props.activeStudent
      })));
    });
    _this.state = {
      loading: false,
      end: Moment().format('YYYY-MM-DD'),
      start: Moment().subtract(6, 'months').format('YYYY-MM-DD')
    };
    return _this;
  }
  _inherits(CompulsorySchoolSection, _Component);
  return _createClass(CompulsorySchoolSection, [{
    key: "render",
    value: function render() {
      var group = this.props.group;
      if (!group || this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderGroupContent());
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    group: state.groups.activeGroup,
    activeStudent: state.User.activeStudent
  };
};
export default connect(mapStateToProps)(CompulsorySchoolSection);